module.exports = __webpack_public_path__ + "img/22.5f37dfa3.png";